import React from 'react';
import PropTypes from 'prop-types';

/**
 * Партнерки рнет могут рендерится в топиках в бесконечном скролле
 * несколько раз. При этом им нужно каждый раз передавать разные blockId из
 * списка blockIds. При переходе в другой топик отсчет blockIds начинается
 * заново.
 *
 * Эта логика очень похожа на pageNumbers, который используется в рекламе,
 * поэтому используем тут механизм pageNumbers, для определения порядкового
 * номера отрендереного блока, чтобы не дублировать логику.
 */
import { withPageNumbers } from 'core/components/Ad/resolve/pageNumbers';
import styles from './index.styl';


function RnetJs(props) {
  const {
    blockId,
    blockIds,
    incrementPageNumber,
    getPageNumber,
  } = props;

  // Идентифиатор блока в объекте pageNumbers
  // TODO: использование blockIds приводит к добавлению в id
  // только первого элемента массива. Наверно, стоит делать `blockIds.join('_')`
  const rnetId = React.useRef('rnet_' + (blockId || blockIds));

  // Порядковый номер отрендереного компонента
  const currentCount = React.useRef(getPageNumber(rnetId.current));

  // Расчитываем текущий blockId, который соответствует currentCount
  const currentBlockId = React.useRef(blockId || blockIds[(currentCount.current - 1) % blockIds.length]);

  const elementId = React.useRef(`rnet_id_${currentBlockId.current}_${currentCount.current}`);

  React.useEffect(() => {
    incrementPageNumber(rnetId.current);

    if (!process.env.BROWSER_RUNTIME) return;

    if (!window.re) {
      /* eslint-disable */
      (function (i, s, o, g, r, a, m) {
      i['RamblerExchangeObject'] = r; i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
      }; a = s.createElement(o), m = s.getElementsByTagName(o)[0];
      a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
      })(window, document, 'script', 'https://api.rnet.plus//Scripts/embed.min.js', 're');
      /* eslint-enable */
    }

    document.getElementById(elementId.current).textContent = '';

    window.re('https://api.rnet.plus/', [{ blockId: currentBlockId.current, elementId: elementId.current }]);
  }, [incrementPageNumber]);

  return (
    <div className={styles.rnet} id={elementId.current} />
  );
}

RnetJs.propTypes = {
  /**
   * Идентификаторы блока
   */
  blockIds: PropTypes.arrayOf(PropTypes.number),
  blockId: PropTypes.number,
  incrementPageNumber: PropTypes.func.isRequired,
  getPageNumber: PropTypes.func.isRequired,
};

export default withPageNumbers(RnetJs);
